export default {
  path: '/help',
  component: () => import('@/views/help/Layout.vue'),
  meta: { name: '' },
  children: [
    { path: '/help', redirect: '/help/document' },
    {
      path: 'document',
      name: 'document',
      meta: { title: '' },
      component: () => import('@/views/help/Document.vue')
    }
  ]
}
